import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

export default function QuestionCard({ question }) {
  const navigate = useNavigate();

  return (
    <div 
      onClick={() => navigate(`/app/comunidad/faq/${question.id}`)}
      className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-2xl p-6 hover:shadow-lg transition-all duration-300 cursor-pointer group flex flex-col md:flex-row gap-6 relative overflow-hidden"
    >
      {/* Indicador de Curada (Borde Izquierdo) */}
      {question.hasCuratedAnswer && (
        <div className="absolute left-0 top-0 bottom-0 w-1 gfi-gradient-bg" />
      )}

      {/* Stats Col */}
      <div className="flex flex-row md:flex-col items-center md:items-start gap-4 md:w-24 shrink-0 border-b md:border-b-0 border-[var(--border-subtle)] pb-4 md:pb-0">
        <div className="flex flex-col items-center justify-center p-2 rounded-xl bg-[var(--bg-base)] border border-[var(--border-subtle)] min-w-[4rem]">
          <span className="text-lg font-black text-[var(--text-main)] mb-0.5">{question.answersCount}</span>
          <span className="text-[8px] font-bold uppercase tracking-widest text-[var(--text-secondary)]">Respuestas</span>
        </div>
        
        {question.hasCuratedAnswer && (
          <div className="flex items-center gap-1.5 px-2 py-1 bg-brand-gold/10 text-brand-gold-dark rounded-lg border border-brand-gold/30 w-full justify-center md:justify-start">
            <SafeIcon name="CheckCircle" className="w-3.5 h-3.5 shrink-0" />
            <span className="text-[8px] font-black uppercase tracking-widest">Resuelta</span>
          </div>
        )}
      </div>

      {/* Content Col */}
      <div className="flex-1 flex flex-col">
        <div className="flex gap-2 mb-3">
          <span className="px-2 py-0.5 bg-[var(--bg-base)] border border-[var(--border-subtle)] text-[var(--text-main)] rounded text-[9px] font-black uppercase tracking-widest">
            {question.category}
          </span>
        </div>
        
        <h3 className="text-lg md:text-xl font-black text-[var(--text-main)] leading-tight mb-3 group-hover:text-brand-cyan transition-colors">
          {question.title}
        </h3>
        
        <p className="text-sm font-medium text-[var(--text-secondary)] line-clamp-2 mb-4 leading-relaxed">
          {question.description}
        </p>

        <div className="mt-auto flex items-center justify-between pt-4 border-t border-[var(--border-subtle)]">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-full bg-brand-navy flex items-center justify-center text-[10px] font-black text-white outline outline-2 outline-[var(--bg-surface)]">
              {question.authorAvatar}
            </div>
            <span className="text-[10px] font-bold text-[var(--text-main)] uppercase">{question.author}</span>
          </div>
          <span className="text-[10px] font-bold text-[var(--text-secondary)] uppercase tracking-widest">
            {question.date}
          </span>
        </div>
      </div>
    </div>
  );
}